import { useState } from "react";

import CreditSVG from "@/../../hypetrain/static/img/credit.svg";
import { useSearchParams } from "react-router-dom";

import { formatMoney, pluralize } from "@/components/helpers/string-utils";
import EmbedSvg from "@/components/helpers/ui/EmbedSvg";
import { allowBuyCredits } from "@/components/helpers/workspace/permissions";
import { Box, Flex } from "@/components/layout/flexbox";
import Clickable from "@/components/pieces/interaction/Clickable";
import { SUBTEXT_COLOR } from "@/css/constants";

import CreditExplainerModal from "./CreditExplainerModal";

export default function ProductPrice({
  product,
  creditPrice = null,
  minCreditPrice = null,
  maxCreditPrice = null,
  usdPrice = null,
  minUsdPrice = null,
  maxUsdPrice = null,
}) {
  const [creditExplainerVisible, setCreditExplainerVisible] = useState(false);
  // this is a secret url param override that hides the USD price.
  // it is useful for demos where we want to avoid anchoring a specif
  // usd price.
  const [searchParams] = useSearchParams();
  const np = searchParams.get("np");
  const showPrice = !np;

  if (!creditPrice && !minCreditPrice && !maxCreditPrice) {
    return <>Customized to your needs</>;
  }

  const creditLabel = (
    <>
      <EmbedSvg src={CreditSVG} height={18} width={18} />{" "}
      {creditPrice
        ? pluralize(creditPrice, "credit", "credits", true)
        : minCreditPrice === maxCreditPrice
          ? pluralize(minCreditPrice, "credit", "credits", true)
          : `${minCreditPrice} to ${maxCreditPrice} credits`}
    </>
  );
  const usdLabel = showPrice && usdPrice && (
    <>
      {usdPrice
        ? formatMoney(usdPrice, 0)
        : minUsdPrice === maxUsdPrice
          ? formatMoney(minUsdPrice, 0)
          : `${formatMoney(minUsdPrice, 0)} to ${formatMoney(maxUsdPrice, 0)}`}
    </>
  );

  if (allowBuyCredits() && usdLabel) {
    return (
      <>
        <Flex alignItems="center" flexWrap="wrap">
          <Box fontSize={18} fontWeight={500} mr={2}>
            {usdLabel}
          </Box>
          <Box
            color={SUBTEXT_COLOR}
            style={{
              borderBottom: "1px dashed",
            }}
          >
            <Clickable onClick={() => setCreditExplainerVisible(true)}>
              <span>or {creditLabel}</span>
            </Clickable>
          </Box>
        </Flex>
        {product ? (
          <CreditExplainerModal
            minCredits={creditPrice || minCreditPrice}
            visible={creditExplainerVisible}
            onClose={() => setCreditExplainerVisible(false)}
          />
        ) : null}
      </>
    );
  } else {
    return creditLabel;
  }
}
